export class TransactionType {
  transactionTypeId!: number;
  name!: string;
  description!: string;
  isActive!: boolean;
}
